export class Publication {
    public __classname__: string = 'Publication';

    public Id : string | null = null;

    public Name : string | null = null;   
    
    constructor(params : PublicationNamedParameters) {
        this.Id = params.Id ?? null;
        this.Name = params.Name ?? null;
    }
}

export interface PublicationNamedParameters {
    Id? : string 
    Name? : string
}